import Vue from "vue";
import App from "./App.vue";
import { sync } from "vuex-router-sync";
import router from "./router";
import store from "./store";
sync(store, router);

import "./assets/style.sass";

//Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowUp,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faCheck,
  faExclamationTriangle,
  faSmileWink,
  faSadTear,
  faMapMarkerAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faArrowUp,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faCheck,
  faExclamationTriangle,
  faSmileWink,
  faSadTear,
  faMapMarkerAlt
);
Vue.component("v-fa", FontAwesomeIcon);

// Swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
import "swiper/css/swiper.css";
import "swiper/components/effect-fade/effect-fade.scss";

// A-FRAME
//override A-frame touch-controls
import "@/aframe/look-controls";
//ignore A-frame elements
Vue.config.ignoredElements = [
  "a-scene",
  "a-assets",
  "a-entity",
  "a-sky",
  "a-box",
  "a-sphere"
];

// vue-progressbar
import VueProgressBar from "vue-progressbar";
import { theme } from "../tailwind.config";
const progressBarOptions = {
  color: theme.extend.colors.bolt,
  thickness: ".25rem"
};
Vue.use(VueProgressBar, progressBarOptions);

// vue-konva
import Konva from "konva";
import VueKonva from "vue-konva";
Konva.pixelRatio = 1;
Vue.use(VueKonva);

// global mixin
import htmlFormatter from "@/components/mixin/htmlFormatter";
Vue.mixin(htmlFormatter);
import deviceHandler from "@/components/mixin/deviceHandler";
Vue.mixin(deviceHandler);

Vue.config.productionTip = false;

// make model
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
